import { createFileRoute } from "@tanstack/react-router";
import { RoleLoginForm } from "@/components/auth/RoleLoginForm";

export const Route = createFileRoute("/login/patient")({
  component: () => <RoleLoginForm role="patient" />,
});
